import styled from 'styled-components'

export const Description = styled.div`
  color: #757575;
  font-weight: 700;
  font-size: 14px;
`
